export default __webpack_public_path__ + "static/media/no-profile-pic.c3f7bfb2.svg";